module.exports = __webpack_public_path__ + "img/耳机_客服_headset-one.d63f2076.png";